import {INVITED_LOBBY_JOIN_OUTCOMES} from '../lobby/resolveInvitedLobbyJoinOutcome';
import {
  TEXT_AI_MATCH_JOIN_AUTH_REQUIRED,
  TEXT_AI_MATCH_JOIN_FAILED,
  TEXT_AI_MATCH_JOIN_LOBBY_CLOSED,
  TEXT_AI_MATCH_JOIN_LOBBY_FULL,
  TEXT_AI_MATCH_JOIN_NETWORK_ERROR,
  TEXT_AI_MATCH_JOIN_PHASE_STARTED,
} from '../../constants/text/aiMatch';

// Исход, которого нет у resolveInvitedLobbyJoinOutcome: запрос до сервера не
// дошел (fetch отверг промис)
export const AI_LOBBY_JOIN_NETWORK_ERROR = 'NETWORK_ERROR';

// Вход в ИИ-лобби — только с настоящим входом: нет JWT-куки (протухла,
// вышли в другой вкладке) или она от другого аккаунта, чем профиль на экране
const AUTH_ERRORS = new Set(['AUTH_REQUIRED', 'AUTH_MISMATCH']);
// Лобби дня больше нет: матч закончился, день отменен, сервер перезапущен
const CLOSED_ERRORS = new Set(['Lobby not found', 'LOBBY_CLOSED', 'AI_PROMO_CANCELLED']);

/**
 * Текст отказа входа в лобби «Битвы с AI Claude Opus» из главного меню.
 *
 * @param {Object} outcome - исход resolveInvitedLobbyJoinOutcome
 *   ({kind, status?, error?}) либо {kind: AI_LOBBY_JOIN_NETWORK_ERROR}
 * @returns {string}
 */
export const getAiLobbyJoinErrorText = (outcome) => {
  const {kind, status, error} = outcome || {};
  if (kind === AI_LOBBY_JOIN_NETWORK_ERROR) return TEXT_AI_MATCH_JOIN_NETWORK_ERROR;
  if (kind === INVITED_LOBBY_JOIN_OUTCOMES.LOBBY_IS_FULL) return TEXT_AI_MATCH_JOIN_LOBBY_FULL;
  if (kind === INVITED_LOBBY_JOIN_OUTCOMES.RANK_MATCH_PHASE_STARTED) return TEXT_AI_MATCH_JOIN_PHASE_STARTED;
  if (status === 401 || AUTH_ERRORS.has(error)) return TEXT_AI_MATCH_JOIN_AUTH_REQUIRED;
  if (status === 404 || CLOSED_ERRORS.has(error)) return TEXT_AI_MATCH_JOIN_LOBBY_CLOSED;
  return TEXT_AI_MATCH_JOIN_FAILED;
};
